"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) {
    var URL = virtual.transparent48
        ? virtual.URL.ws48
        : virtual.transparent48v2
            ? virtual.URL.ws48v2
            : virtual.URL.ws;
    var webSocket = new WebSocket(URL);
    webSocket.addEventListener('open', function () {
        if (virtual.device.devType === 'GATEWAY') {
            virtual.send('requestVerify');
        }
        else {
            virtual.send('devLogin');
        }
    });
    webSocket.addEventListener('message', function (event) {
        if (event) {
            virtual.receive(event.data);
        }
    });
    webSocket.addEventListener('close', function (event) {
        if (event) {
            console.error(event.type + ":" + event.code);
        }
        // 是否重连
        if (virtual.options.reconnect) {
            virtual.connect();
        }
    });
    return webSocket;
});



// WEBPACK FOOTER //
// ./src/webSocket.ts